
import { usePinia, useSearchWizardStore } from '#imports'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ensureArray } from '~/utility/array'
import { SearchFiltersUrl } from '../../url/search-filters/SearchFiltersUrl'

@Component({
  setup() {
    const searchWizardStore = useSearchWizardStore(usePinia())
    return { searchWizardStore }
  },
})
export default class SearchNavBar extends Vue {
  searchWizardStore: ReturnType<typeof useSearchWizardStore>

  // @Prop({ required: true, type: Object })
  // searchFilters: SearchFilters
  get searchFilters() {
    return this.searchWizardStore.wizardFilters
  }

  // @Prop({ type: Object })
  //   searchCounts?: SearchCountsResults

  @Prop({ required: true })
    resultsCount: number

  @Prop({ default: false, type: Boolean })
    showMap: boolean

  @Prop({ required: false })
    visibleMarker?: { slug: string; point: string }

  @Prop({ required: false })
    mapCentre?: string

  @Prop()
    selectedHierarchyName: string

  get placename() {
    return ensureArray(this.$route.query.placename)[0] || undefined
  }

  onFilterCancel() {
    this.searchWizardStore.panelOpen = false
  }

  get mapUrlQueryParams() {
    return {
      facet: this.searchFilters.facets,
      ...this.mapUrlVisibleMarkerQuery,
      ...this.mapUrlPlaceNameQuery,
    }
  }

  get mapUrlVisibleMarkerQuery() {
    return this.visibleMarker
      ? {
        visibleMarker: this.visibleMarker.slug,
      }
      : {}
  }

  get mapUrlPlaceNameQuery() {
    const placename = ensureArray(this.$route.query.placename)[0] || undefined
    return placename ? { placename } : {}
  }

  get filterAndSortUrlQuery() {
    const route = this.searchFilters
      ? SearchFiltersUrl.filtersToUrl(this.searchFilters).route
      : { query: {} }
    return {
      ...route.query,
      hierarchyPath: this.hierarchyPath,
      targetUrl: this.showMap ? 'maps' : 'search',
    }
  }

  get hierarchyPath() {
    return this?.searchFilters?.hierarchyPath
      ? this.searchFilters.hierarchyPath
      : ''
  }
}
